import React, { useState } from "react"
import styled, { useTheme } from '~/ui/styled'
import { observer } from "mobx-react-lite"
import useNavigation from "~hooks/useNavigation"
import { APP_MAX_WIDTH } from "~ui/app-shell"
import { IconFont, Button, Text, CenterFlex } from "~components/El"
import { Platform, Modal, Dimensions } from "~/ui/primitives"
import { useStores } from "~models"
import logo from "~assets/images/app-intro-logo.png"

const DATA = [
  {
    title: "发起群聊",
    icon: "cjql",
    link: "AddGroupChat",
  },
  {
    title: "创建频道",
    icon: "cjpd",
    link: "AddChannel",
  },
  {
    title: "添加好友",
    icon: "tjhy",
    link: "AddContact",
  },
  {
    title: "扫一扫",
    icon: "ewm",
    link: "QrcodeScan",
  },
]

const Mask = styled.Pressable`
  width: 500px;
  height: 100vh;
  margin: 0 auto;
  left:0,
  right:0;
  background-color: ${({ theme }) => theme.colors.mask};
`

const Container = styled(CenterFlex)`
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  position: relative;
  z-index: 2;
`
const ListWrap = styled.View`
  background-color: ${({ theme }) => theme.colors.blockBackground};
  position: fixed;
  top: 48px;
  right: max(10px, calc(50vw - min(${APP_MAX_WIDTH / 2}px, 50vw) + 10px));
  border-radius: 7px;
  padding: 10px 5px;
  z-index: 10001;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
`
const Arrow = styled.View`
  width: 12px;
  height: 12px;
  background-color: ${({ theme }) => theme.colors.blockBackground};
  transform: rotate(45deg);
  position: absolute;
  right: 15px;
  top: -6px;
`
const List = styled.FlatList`
  height: auto;
  width: 100%;
  flex-direction: column;
`

const ItemSection = styled.Pressable`
  padding: 10px;
  flex-direction: row;
  align-items: center;
`

const Space = styled.View`
  margin-left: auto;
  width: 70%;
  height: 1px;
`

const LogoWrap = styled.div`
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.secondary};

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

type ItemProps = {
  id: string
  index: number
  title: string
  icon: string
  link: string
  color: string
  onClick?: (link: string) => void
}

const Item = ({ title, icon, link, onClick, color }: ItemProps) => {
  const theme = useTheme()
  return (
    <ItemSection onClick={() => onClick(link)}>
      <IconFont name={icon} size={16} color={color} />
      <Text color={theme.colors.text} fontSize="14px" ml="10px" >{title}</Text>
    </ItemSection>
  )
}
export const Dropdown = observer(() => {
  const theme = useTheme()
  const { notificationStore } = useStores()
  const unreadCount = notificationStore.userUnreadNotificationCount
  const [listOpen, setListOpen] = useState(false)
  const navigation = useNavigation()
  const handleAction = (link) => {
    navigation.navigate(link)
    setListOpen(false)
  }
  return (
    <Container>
      <Button
        height="30px"
        padding="0 10px"
        style={{
         position: "relative",
        }}
        onClick={() => {
          navigation.navigate("NoticeCenter")
        }}
      >
        <IconFont
          name="sykq"
          size={18}
          color={theme.colors.text}
        />
        {unreadCount > 0 && (
          <CenterFlex
            position="absolute"
            right="10px"
            top="4px"
            width="6px"
            height="6px"
            borderRadius="3px"
            bg={theme.colors.danger}
          ></CenterFlex>
        )}
      </Button>
      <Button
        width="30px"
        height="30px"
        borderRadius="15px"
        backgroundColor={theme.colors.background}
        onClick={() => setListOpen(!listOpen)}
      >
        <IconFont
          name="jh"
          size={14}
          color={theme.colors.text}
        />
      </Button>
      
      <Modal animationType="fade" transparent={true} visible={listOpen}>
        <Mask onClick={() => setListOpen(false)} />
        <ListWrap>
          <Arrow />
          <List
            data={DATA}
            renderItem={({ item }: { item: any }) => (
              <Item {...item} color={theme.colors.text} onClick={handleAction} />
            )}
            keyExtractor={(item) => item.link}
            ItemSeparatorComponent={Space}
          />
        </ListWrap>
      </Modal>
    </Container>
  )
})

export const LogoHeader = observer(() => {
  const theme = useTheme()
  return (
    <CenterFlex flexDirection="row">
      <LogoWrap>
        <img src={logo} alt="" />
      </LogoWrap>
      <Text color={theme.colors.text} fontSize="16px" fontWeight={600} ml="6px">
        企鹅
      </Text>
    </CenterFlex>
  )
})
